import RegistrationTableItem from "root/s360components/Registration/RegistrationTableItem";
import {RegistrationFormSections} from "root/s360components/Registration/RegistrationPage";
import {useFieldArray} from "react-hook-form";
import {useEffect, useState} from "react";
import {getAbsenceStatus} from "root/s360components/ReactHookForm/ui/DropdownAbsenceStatus";
import {getAbsenceCode, getAbsenceCodes} from "root/s360components/ReactHookForm/ui/DropdownAbsenceCode";
import {getLunchOption, getLunchOptions} from "root/s360components/ReactHookForm/ui/DropdownLunchOption";

export const EMPTY_ABSENCE_CODE = {value: "0", label: "N/A", requires_comment: 0};
export const ChildRegistrationDetails = {
    ABSENCE_STATUS: "absence_status",
    ABSENCE_CODE: "absence_code",
    ABSENCE_COMMENTS: "absence_comment",
    LUNCH_OPTION: "lunch_option",
    MINUTES_LATE: "minutes_late",
}





const childRegItem = (data) =>
{
    const absenceCodes = getAbsenceCodes(data.absenceCodes, true);

    const lunchOptions = getLunchOptions(data.lunchOptions);

    const values = data.pupils.reduce ((accum, current) =>
    {
        const absence_status = getAbsenceStatus(current.absence_code);

        const absence_code = getAbsenceCode(current.absence_code, absenceCodes);

        const lunch_option = getLunchOption(current.lunch_option, lunchOptions);


        const fval = {
            [ChildRegistrationDetails.ABSENCE_STATUS]: absence_status,
            [ChildRegistrationDetails.ABSENCE_CODE]: absence_code,
            [ChildRegistrationDetails.ABSENCE_COMMENTS]: current.notes,
            [ChildRegistrationDetails.LUNCH_OPTION]: lunch_option,
            [ChildRegistrationDetails.MINUTES_LATE]: current.minutes_late !== null ? current.minutes_late : '', //Value prop on input needs to be empty string when controlled in hook form
        } ;

        accum['pupil' + current.uid] = fval ;
        return accum ;
    },{}) ;

    return values;
}

export const childRegFields = (data) =>
{
    return {
        [RegistrationFormSections.REGISTRATION]:{
            ...childRegItem(data)
        }
    }
}

const HookSubFormRegistrationTable = ({control, formErrors, data, fields, showLunchDropdown, watch, trigger, setValue, isArbor}) =>
{

    const [lateCodeActive, setLateCodeActive] = useState(false);

    const absenceCodes = getAbsenceCodes(data.absenceCodes, true);

    const lunchOptions = getLunchOptions(data.lunchOptions);

    const showMinutesLate = isArbor === true && lateCodeActive === true;


    return (
        <div>
            <table className='table'>
                <thead>
                <tr>
                    <th scope="col">Forename</th>
                    <th scope="col">Surname</th>
                    <th scope="col">Absence Status</th>
                    <th scope="col">Absence Code</th>
                    <th scope="col">Absence Comments</th>
                    {showLunchDropdown === true && <th scope="col">Lunch Option</th>}
                    {showMinutesLate === true && <th scope="col">Minutes Late</th> }
                </tr>
                </thead>
                <tbody>
                    {data.pupils.map((itemData, index) => {
                        return <RegistrationTableItem itemData={itemData} trigger = {trigger} setValue={setValue} watch = {watch} control = {control} uid = {itemData.uid} key = {itemData.uid} sectionName={RegistrationFormSections.REGISTRATION} absenceCodes={absenceCodes} showLunchDropdown={showLunchDropdown} lunchOptions={lunchOptions} lateCodeActive={lateCodeActive} setLateCodeActive={setLateCodeActive} showMinutesLate={showMinutesLate}/>
                    })}

                </tbody>
            </table>
        </div>
    )
}

export default HookSubFormRegistrationTable;